// Sync Action Types

export const REQUEST_INIT = "REQUEST_IN";
export const REQUEST_SUCCESS = "REQUEST_SUCC";
export const REQUEST_FAILURE = "REQUEST_FAIL";
export const REMOVE_DATA = "REMOVE_DATA";

// Async action type

export const FETCH_USER_DATA = "FETCH_ONE_USER_DATA";
